import { Dispatch, SetStateAction } from "react";
import { Box, Switch, Tooltip, Typography } from "@mui/material";

import { EditableCardRow } from "../../../components/common";

import { useSessionContext } from "../../../contexts/SessionContext";
import { useFormatter } from "../../../utils/useFormatter";
import { NotificationPatch } from "../../../services/scim/profile/NotificationPatch";
import { ProfileSection, ProfileSectionDivider } from "./ProfileSection";

interface IProps {
  setIsEditEmailOpen: Dispatch<SetStateAction<boolean>>;
  setIsEditPhoneOpen: Dispatch<SetStateAction<boolean>>;
}

export function CardContact({
  setIsEditEmailOpen,
  setIsEditPhoneOpen,
}: IProps) {
  const { user, fetchUser } = useSessionContext();

  /**
   * Atualiza a preferência de notificações por WhatsApp do usuário
   * - Chama o serviço NotificationPatch para fazer o PATCH no Patient
   * - Em seguida, atualiza os dados do usuário no contexto
   */
  const handleSubmit = async (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      await NotificationPatch({
        idUser: user?.id,
        operation: "replace",
        valueField: `${e.target.checked}`,
      });
    } catch (err) {
      console.log("Erro ao atualizar notificações:", err);
    } finally {
      fetchUser();
    }
  };

  return (
    <ProfileSection title="Contato">
      <EditableCardRow
        title="E-mail"
        titleContext={user?.email}
        onClick={() => {
          setIsEditEmailOpen(true);
        }}
      />
      <ProfileSectionDivider />
      <EditableCardRow
        title="Telefone"
        titleContext={useFormatter.formatPhoneNumber(user?.phone)}
        onClick={() => {
          setIsEditPhoneOpen(true);
        }}
      />
      <ProfileSectionDivider />
      {/* Bloco de notificações por WhatsApp */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.5,
          px: { xs: 1.5, sm: 2.5, md: 3 },
          pl: { xs: 1.5, sm: 2.5, md: 5 },
          py: { xs: 1.25, sm: 2, md: 2.5 },
        }}
      >
        <Typography
          variant="body2"
          sx={{
            fontWeight: 500,
            color: "text.secondary",
            fontSize: { xs: "0.8125rem", sm: "0.875rem" },
          }}
        >
          Notificações por WhatsApp
        </Typography>
        <Tooltip
          title={
            user?.notificationAgree === "true"
              ? "Desativar notificações"
              : "Ativar notificações"
          }
          arrow
        >
          <Switch
            defaultChecked={user?.notificationAgree === "true"}
            onChange={(e) => handleSubmit(e)}
          />
        </Tooltip>
      </Box>
    </ProfileSection>
  );
}
